/**
 * SSR-safe localStorage access for the Flô FAB/insight-banner per-browser flags (opened-before,
 * callout/banner signatures, dismissal). `localStorage` is absent during server rendering, and these
 * components can be constructed there — so reads no-op to null and writes no-op, matching how the
 * rest of the Flô code guards browser-only APIs (`typeof … === 'undefined'`).
 */
export function lsGet(key: string): string | null {
	return typeof localStorage === 'undefined' ? null : localStorage.getItem(key);
}

export function lsSet(key: string, value: string): void {
	if (typeof localStorage !== 'undefined') localStorage.setItem(key, value);
}

export function lsRemove(key: string): void {
	if (typeof localStorage !== 'undefined') localStorage.removeItem(key);
}
